import _regeneratorRuntime from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import localeMixin from '@/locales/mixin.js';
import verifyCode from '@/components/common/verifyCode';
import helper from '@/libs/helper.js';
import axios from '@/plugin/axios';
import util from '@/libs/util.js';
export default {
  mixins: [localeMixin],
  data: function data() {
    return {
      helper: helper,
      title: '韶关市青少年体育信息管理系统',
      timeInterval: null,
      time: dayjs().format('HH:mm:ss'),
      // 快速选择用户
      dialogVisible: false,
      users: [],
      // 验证码初始值
      identifyCode: '1234',
      // 验证码的随机取值范围
      identifyCodes: '1234567890',
      // 表单
      formLogin: {
        username: '',
        password: '',
        code: ''
      },
      checkCode: '',
      // 表单校验
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        placeId: 0
      }
    };
  },
  components: {
    'v-code': verifyCode
  },
  created: function created() {
    util.cookies.remove('token');
    util.cookies.remove('uuid');
    util.cookies.remove('token');
    util.cookies.remove('uuid');
    localStorage.removeItem("username");
    localStorage.removeItem("admin_id");
    localStorage.removeItem("appkey");
    localStorage.removeItem("business_id");
    localStorage.removeItem("apcode");
    this.createCode();
  },
  mounted: function mounted() {
    var _this = this;
    this.identifyCode = '';
    this.makeCode(this.identifyCodes, 4);
    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['login'])), {}, {
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    },
    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick: function handleUserBtnClick(user) {
      this.formLogin.username = user.username;
      this.formLogin.password = user.password;
      this.submit();
    },
    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit: function submit() {
      var _this2 = this;
      // console.log(this.formLogin);
      // console.log(this.identifyCode);
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          // 登录
          // 注意 这里的演示没有传验证码
          // 具体需要传递的数据请自行修改代码
          if (_this2.formLogin.code != _this2.identifyCode) {
            _this2.$message.error('验证码错误');
          } else {
            _this2.login({
              username: _this2.formLogin.username,
              password: _this2.formLogin.password
            }).then(function (res) {
              console.log(res);
              console.log("登录完成");
              // 重定向对象不存在则返回顶层路径
              _this2.$router.replace(_this2.$route.query.redirect || '/');
              // this.loadData();
              if (localStorage['username']) {
                _this2.loadMenu();
              }
            });
          }
        } else {
          // 登录表单校验失败
          _this2.$message.error('表单校验失败，请检查');
          _this2.changeCode();
        }
        _this2.changeCode();
      });
    },
    loadData: function loadData() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var that, url, data, response, placeId, flag;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // console.log('load data');
              that = _this3;
              url = helper.apiHost + helper.apiUrl.getIndexSelectList;
              data = {};
              _context.next = 5;
              return axios(url, {
                params: data
              });
            case 5:
              response = _context.sent;
              if (response.code == 0) {
                _this3.options = response.data;
                placeId = localStorage.getItem('place_id'); // console.log('storage data', placeId);
                if (placeId) {
                  placeId = parseInt(placeId);
                  that.placeId = parseInt(placeId);
                }
                if (response.data.length > 0) {
                  // console.log('res data', response.data[0]);
                  // console.log('res data', response.data);
                  flag = false;
                  response.data.forEach(function (item) {
                    if (item.id == placeId) {
                      flag = true;
                    }
                  });
                  if (!flag) {
                    that.value = response.data[0].id;
                    that.placeId = response.data[0].id;
                    // console.log('res', response.data[0].id);
                    localStorage.setItem('place_id', response.data[0].id);
                  } else {
                    that.value = placeId;
                  }
                }
                that.loadMenu();
                console.log('placeid', localStorage.getItem('place_id'));
              } else {}
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loadMenu: function loadMenu() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data, url, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // console.log('load menu1');
              //加载菜单
              // console.log('data placeid', this.placeId);
              data = {
                id: localStorage['admin_id'],
                username: localStorage['username']
              }; // console.log("menu data2",data);
              url = helper.apiHost + helper.apiUrl.menuList;
              _context2.next = 4;
              return axios({
                url: url,
                method: 'post',
                data: data
              });
            case 4:
              res = _context2.sent;
              // console.log("menu res",res);
              _this4.$store.commit('d2admin/menu/asideSet', res.data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    createCode: function createCode() {
      var code = "";
      var codeLength = 4; //验证码的长度
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'); //随机数
      for (var i = 0; i < codeLength; i++) {
        //循环操作
        var index = Math.floor(Math.random() * 36); //取得随机数的索引（0~35）
        code += random[index]; //根据索引取得随机数加到code上
      }

      this.checkCode = code; //把code值赋给验证码
    },
    // 点击验证码刷新验证码
    changeCode: function changeCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
    },
    // 生成一个随机整数  randomNum(0, 10) 0 到 10 的随机整数， 包含 0 和 10
    randomNum: function randomNum(min, max) {
      max = max + 1;
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 随机生成验证码字符串
    makeCode: function makeCode(data, len) {
      for (var i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)];
      }
    }
  })
};